import { apiFetch } from "./client";

export function lookupTax({ address, zip, county }) {
  return apiFetch("/api/tax/lookup", {
    method: "POST",
    body: {
      address: address || "",
      zip: zip || "",
      county: county || "",
    },
  });
}

export function listFloridaCounties() {
  return apiFetch("/api/tax/counties");
}

export function formatRatePercent(basisPoints) {
  if (basisPoints == null) return "";
  return `${(Number(basisPoints) / 100).toFixed(3).replace(/\.?0+$/, "")}%`;
}
